export const templatePrecificacaoSearch = {
  label: 'Template de Precificação',
  placeholder: 'ID ou Nome...',
  titulo: 'Pesquisar Template de Precificação',
  endpointApi: 'TemplatesPrecificacao',
  idField: 'idTemplatePrecificacao',
  displayField: 'idTemplatePrecificacao',
  descField: 'nome',
  tabela: 'TemplatePrecificacao',
  camposFiltro: [
    { model: 'busca', label: 'Nome do Template', tipo: 'text' }
  ],
  colunasGrid: [
    { header: 'ID', dataField: 'idTemplatePrecificacao', width: '10%' },
    { header: 'Nome do Template', dataField: 'nome', width: '50%' },
    { header: 'Status', dataField: 'lstStatus', width: '20%' }
  ]
}
